import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function QualityCheckDialog({ open, onOpenChange, checklist, onChecklistChange, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[var(--bg-card)] border-[var(--border-strong)] text-[var(--text-primary)]">
        <DialogTitle>First-draft quality check</DialogTitle>
        <p className="text-sm text-[var(--text-muted)] mb-3">Before first publish, confirm the draft aligns with your voice and strategy.</p>
        <div className="space-y-2 text-sm">
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={checklist.voice} onChange={(e) => onChecklistChange({ ...checklist, voice: e.target.checked })} />
            Voice matches your tone and POV
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={checklist.strategy} onChange={(e) => onChecklistChange({ ...checklist, strategy: e.target.checked })} />
            Strategy angle supports your goal
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={checklist.clarity} onChange={(e) => onChecklistChange({ ...checklist, clarity: e.target.checked })} />
            CTA and next step are clear
          </label>
        </div>
        <Button
          disabled={!checklist.voice || !checklist.strategy || !checklist.clarity}
          onClick={onConfirm}
          className="mt-4 bg-[#FF4400] hover:bg-[#FF6633] text-white"
        >
          Confirm and save draft
        </Button>
      </DialogContent>
    </Dialog>
  );
}
